export default {
  // TODO - REMOVE WHEN WE STOP USING VIDEO CALL V1
  LEAVE_CALL: `Leave Call`,
  OPEN_DEVICE_SETTINGS: `Open Device Settings`,
  WAITING_ON_PROVIDER: `Waiting on Provider`,
  DISABLE_CAMERA: `Disable Camera`,
  ENABLE_CAMERA: `Enable Camera`,
  LOADING: `Loading`,
  UNMUTE_MICROPHONE: `Unmute Microphone`,
  MUTE_MICROPHONE: `Mute Microphone`,

  // NEW
  IS_SCREEN_SHARING: 'is screen sharing',

  RELATIONSHIP_PATIENT: 'patient',
  RELATIONSHIP_CAREGIVER: 'caregiver',
  RELATIONSHIP_FAMILY: 'family member',
  RELATIONSHIP_FRIEND: 'friend',
  RELATIONSHIP_PROVIDER: 'another care provider',
  RELATIONSHIP_INTERPRETER: 'interpreter',
  RELATIONSHIP_OTHER: 'other',

  //Audio only toast
  TOAST_AUDIO_ONLY_HEADER: 'Switch to audio only?',
  TOAST_AUDIO_ONLY_CONTENT: 'We’ll turn off all video feeds to improve your call quality.',
  TOAST_AUDIO_ONLY_DISMISS: 'Dismiss',
  TOAST_AUDIO_ONLY_YES: 'Yes',

  //Video quality lowered toast
  TOAST_VIDEO_QUALITY_LOWERED_HEADER: `Video Quality Lowered`,
  TOAST_VIDEO_QUALITY_LOWERED_CONTENT: `Lowering the video quality to improve your call experience.`,

  //Signal quality
  POOR_QUALITY_SIGNAL: `Poor call signal`,
  GOOD_QUALITY_SIGNAL: `Good call signal`,
  EXCELLENT_QUALITY_SIGNAL: `Excellent call signal`,

  //Auto-reconnect
  RECONNECT_LOADER: `Reconnecting the call...`,
  RECONNECT_BANNER_LABEL: `Please Hold`,
  RECONNECT_BANNER_CONTENT: `Attempting to reconnect you to your visit.`,
  RECONNECT_ERROR_TITLE: `Network Error`,
  RECONNECT_ERROR_CONTENT: `A network error was detected and we were not able to reconnect the call. Please leave the call and log back in. If you continue to see this error, call your practice.`,
  //Page Title
  VIDEO_CALL_TITLE: `Telehealth - Visit In Progress`,
};
